const translations = {
  translation: {
    appTitle: "Convertisseur d'Unités",
    appDescription: 'Convertissez instantanément des unités dans 11 catégories différentes',
    selectCategory: 'Sélectionnez une catégorie',
    categories: {
      length: 'Longueur',
      mass: 'Masse',
      force: 'Force',
      energy: 'Énergie',
      power: 'Puissance',
      pressure: 'Pression',
      temperature: 'Température',
      time: 'Temps',
      volume: 'Volume',
      angle: 'Angle',
      area: 'Surface',
    },
    units: {
      meter: 'Mètre',
      kilometer: 'Kilomètre',
      centimeter: 'Centimètre',
      millimeter: 'Millimètre',
      micrometer: 'Micromètre',
      nanometer: 'Nanomètre',
      mile: 'Mile',
      yard: 'Yard',
      foot: 'Pied',
      inch: 'Pouce',
      nauticalMile: 'Mille Nautique',
      kilogram: 'Kilogramme',
      gram: 'Gramme',
      milligram: 'Milligramme',
      metricTon: 'Tonne Métrique',
      pound: 'Livre',
      ounce: 'Once',
      ton: 'Tonne US',
      stone: 'Stone',
      newton: 'Newton',
      kilonewton: 'Kilonewton',
      poundForce: 'Livre-force',
      kilopoundForce: 'Kililivre-force',
      dyne: 'Dyne',
      joule: 'Joule',
      kilojoule: 'Kilojoule',
      calorie: 'Calorie',
      kilocalorie: 'Kilocalorie',
      wattHour: 'Watt-heure',
      kilowattHour: 'Kilowatt-heure',
      electronvolt: 'Électronvolt',
      btu: 'BTU',
      footPound: 'Pied-livre',
      watt: 'Watt',
      kilowatt: 'Kilowatt',
      megawatt: 'Mégawatt',
      horsepower: 'Cheval-vapeur',
      btuPerHour: 'BTU/heure',
      pascal: 'Pascal',
      kilopascal: 'Kilopascal',
      bar: 'Bar',
      atmosphere: 'Atmosphère',
      psi: 'PSI',
      torr: 'Torr',
      mmHg: 'mmHg',
      celsius: 'Celsius',
      fahrenheit: 'Fahrenheit',
      kelvin: 'Kelvin',
      second: 'Seconde',
      millisecond: 'Milliseconde',
      microsecond: 'Microseconde',
      nanosecond: 'Nanoseconde',
      minute: 'Minute',
      hour: 'Heure',
      day: 'Jour',
      week: 'Semaine',
      month: 'Mois',
      year: 'Année',
      liter: 'Litre',
      milliliter: 'Millilitre',
      cubicMeter: 'Mètre Cube',
      cubicCentimeter: 'Centimètre Cube',
      gallon: 'Gallon',
      quart: 'Quart',
      pint: 'Pinte',
      cup: 'Tasse',
      fluidOunce: 'Once Liquide',
      tablespoon: 'Cuillère à Soupe',
      teaspoon: 'Cuillère à Café',
      degree: 'Degré',
      radian: 'Radian',
      gradian: 'Grade',
      arcminute: "Minute d'Arc",
      arcsecond: "Seconde d'Arc",
      turn: 'Tour',
      squareMeter: 'Mètre Carré',
      squareKilometer: 'Kilomètre Carré',
      squareCentimeter: 'Centimètre Carré',
      squareMillimeter: 'Millimètre Carré',
      hectare: 'Hectare',
      acre: 'Acre',
      squareMile: 'Mile Carré',
      squareYard: 'Yard Carré',
      squareFoot: 'Pied Carré',
      squareInch: 'Pouce Carré',
    },
    from: 'De',
    to: 'À',
    enterValue: 'Entrez la valeur',
    result: 'Résultat',
  },
};

export default translations;
